import React from "react";
import ToolbarContainer from "./Toolbar.styles";

export const Toolbar = ({ children }: { children: React.ReactNode }) => <ToolbarContainer>{children}</ToolbarContainer>;
